var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7119 27.0025L20.3726 20.1917C20.26 20.1255 20.1312 20.0906 20 20.0906C19.8688 20.0906 19.74 20.1255 19.6274 20.1917L8.28805 27.0025C7.75317 27.3236 8.0126 28.0577 8.66067 28.0577H11.5686C11.9327 28.0577 12.2279 28.3167 12.2279 28.6361V34.4219C12.2279 34.741 12.5232 35 12.8876 35H27.1124C27.4768 35 27.7721 34.741 27.7721 34.4219V28.6361C27.7721 28.3167 28.0673 28.0577 28.4314 28.0577H31.3393C31.9874 28.0577 32.2468 27.3236 31.7119 27.0025Z",
    fill: "#52C6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28805 12.9975L19.6274 19.8083C19.74 19.8745 19.8688 19.9094 20 19.9094C20.1312 19.9094 20.26 19.8745 20.3726 19.8083L31.7119 12.9975C32.2468 12.6761 31.9874 11.942 31.3393 11.942H28.4314C28.0673 11.942 27.7721 11.6833 27.7721 11.3639V5.57808C27.7721 5.25868 27.4768 5 27.1124 5H12.8876C12.5232 5 12.2279 5.25868 12.2279 5.57808V11.3639C12.2279 11.6833 11.9327 11.942 11.5686 11.942H8.66067C8.0126 11.942 7.75317 12.6761 8.28805 12.9975Z",
    fill: "#52C6DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirPressure);
export default __webpack_public_path__ + "static/media/airPressure.442427d9df1b997b12b83caa1022382f.svg";
export { ForwardRef as ReactComponent };